import {
  numeroNormalizado,
  limpiarString,
} from '../../../../utils/normalizarDatosUtil';

const FILA_INICIO = 3;

/**
 * Normaliza las filas crudas de la hoja Novedades a objetos con claves del schema.
 * @param {Array} data - Filas del Excel (resultado de hojaAJson con skipRows=1)
 * @returns {Array<Object>}
 */
export const normalizarNovedadesJson = data =>
  data.map((fila, index) => ({
    numeroDocumento: numeroNormalizado(fila['Número de documento']),
    tipoNovedad: fila['Tipo de novedad'] ?? null,
    fechaInicio: fila['Fecha inicio'] ?? null,
    fechaFin: fila['Fecha fin'] ?? null,
    observacion: limpiarString(fila['Observación']),
    lineaExcel: index + FILA_INICIO,
  }));
